import * as React from 'react'
import classnames from 'classnames'

type ContentPlaceholderProps = {
    illustrationSrc?: string
    title?: string
    description?: string
    className?: string
    name: string
}

export const ContentPlaceholder: React.FC<ContentPlaceholderProps> = (
    props
) => {
    const { illustrationSrc, title, description, name } = props

    const className = classnames(
        'flex items-center justify-center rounded-xl border border-neutral-200 bg-neutral-50 p-4 text-center text-regular',
        props.className
    )

    return (
        <div className={className} data-testid={`${name}-wrapper`}>
            <div className="space-y-2">
                {illustrationSrc && (
                    <img
                        className="mx-auto block"
                        src={illustrationSrc}
                        data-testid={`${name}-illustration`}
                    />
                )}
                {(title || description) && (
                    <div className="space-y-2">
                        {title && (
                            <h6
                                className="text-heading-6"
                                data-testid={`${name}-title`}
                            >
                                {title}
                            </h6>
                        )}
                        {description && (
                            <div
                                className="text-sm text-subtle"
                                data-testid={`${name}-description`}
                            >
                                {description}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
